import MessageBox from './src/message-box';

module.exports = MessageBox;


// WEBPACK FOOTER //
// ./src/components/message-box/index.js